/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SITE HEAD MODULE
\*------------------------------------*/
class SiteHead {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.shrink();
    }

    shrink() {
        let self = this;

        // On page load
        var scrollStart = $(window).scrollTop();

        if(scrollStart >= 1) {
            $('.site-head').addClass('is-shrunk');
        }

        // On scroll
        $(window).on("scroll", function() {
            var scroll = $(window).scrollTop();

            if(scroll >= 1) {
                $('.site-head').addClass('is-shrunk');
            }
            else {
                $('.site-head').removeClass('is-shrunk');
            }
        });
    }
}

export default SiteHead;